import ActsList from "./ActsList";

export default ActsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ActsList/index.js